import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { PlanterGroup } from '../../interfaces/planter-group.interface';

@Injectable()
export class PlanterService {

    private _planterGroups: PlanterGroup[];

    constructor(private httpClient: HttpClient) { }

    getPlanters() {
        const token = localStorage.getItem('id_token');
        const headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': token
        };

        return this.httpClient.get(environment.apiEndPoint + '/plantadores', { headers });
    }

    postulateMemberToPlanter(idMember) {
        let token = localStorage.getItem('id_token')
        let headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': token
        }
        let data = {
          user_id: idMember
        }

        return this.httpClient.post(environment.apiEndPoint + '/plantadores/postular', data, {headers});
    }

    planterObservations(data: PlanterObservationRq) {
        let token = localStorage.getItem('id_token')
        let headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': token
        }

        return this.httpClient.post(environment.apiEndPoint + '/plantadores/observaciones', data, {headers});
    }


    getPlanterReports() {
        let token = localStorage.getItem('id_token')
        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': token
        }

        return this.httpClient.get(environment.apiEndPoint + '/plantadores/reportes', { headers });
    }

    getPlanterGroups(): Promise<any> {

        if (this._planterGroups) {

            return Promise.resolve(this._planterGroups);

        }

        return new Promise<any>((resolve, reject) => {

            let token = localStorage.getItem('id_token');
            let headers = new HttpHeaders({
                'Authorization': token
            });

            this.httpClient.get<any[]>(`${environment.apiEndPoint}/plantadores/grupos`, { headers })
                .subscribe(planterGroups => {

                    this._planterGroups = planterGroups;

                    resolve(this._planterGroups);

                }, err => {

                    if (err.status === 401) {

                        reject('No tiene permisos para esta acción');

                    }

                    reject('Ha ocurrido un error en el proceso de obtener datos plantador');

                });

        });

    }

    updatePlanterGroup(planterGroup): Promise<any> {

        return new Promise<any[]>((resolve, reject) => {

            let token = localStorage.getItem('id_token');
            let headers = new HttpHeaders({
                'Authorization': token
            });

            this.httpClient.put<any[]>(`${environment.apiEndPoint}/plantadores/grupos/${planterGroup.id}`, planterGroup, { headers })
                .subscribe(planterGroup => {

                    resolve(planterGroup);

                }, err => {

                    if (err.status === 401) {

                        reject('No tiene permisos para esta acción');

                    }

                    reject('Ha ocurrido un error en el proceso de actualización de datos');

                });

        });

    }

    createPlanterGroup(planterGroup): Promise<any> {

        return new Promise<any[]>((resolve, reject) => {

            let token = localStorage.getItem('id_token');
            let headers = new HttpHeaders({
                'Authorization': token
            });

            this.httpClient.post<any[]>(`${environment.apiEndPoint}/plantadores/grupos`, planterGroup, { headers })
                .subscribe(planterGroup => {

                    resolve(planterGroup);

                }, err => {

                    if (err.status === 401) {

                        reject('No tiene permisos para esta acción');

                    }

                    reject('Ha ocurrido un error en el proceso de actualización de datos');

                });

        });

    }

    deletePlanterGroup(planterGroup): Promise<void> {

        return new Promise<void>((resolve, reject) => {

            let token = localStorage.getItem('id_token');
            let headers = new HttpHeaders({
                'Authorization': token
            });

            this.httpClient.delete<string>(`${environment.apiEndPoint}/plantadores/grupos/${planterGroup.id}`, { headers })
                .subscribe(() => {

                    resolve();

                }, err => {


                    if (err.status === 401) {

                        reject('No tiene permisos para esta acción');

                    }

                    reject('Ha ocurrido un error en el proceso de eliminación del grupo');

                });

        });

    }

}

export interface PlanterObservationRq {
    cause: string
    description: string
    seeder_id: number
    user_id: number
}



// WEBPACK FOOTER //
// ./src/app/services/planter/planter.service.ts